import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import './styles/app.css'
import './api/http'
import { loadCLodop } from './utils/printDoc'

loadCLodop()

const app = createApp(App)
app.config.errorHandler = (err) => {
  if (err && (err.isApiError || err.isAxiosError)) return
  console.error(err)
}
app.use(createPinia()).use(router).use(ElementPlus, { locale: zhCn }).mount('#app')
